import React from "react";

const IOText = (props) => {
    return (<div className="IOT-MainDiv">
        <img src={props.Image} alt={props.Alt} />
        <div className="subtext">
            {props.Text}
        </div>
    </div>)
}
export default IOText;